export default __webpack_public_path__ + "static/michalz-f8f8128334da7dbc65e592221eaadfc3.png";